import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Copy, Mail, Share2 } from "lucide-react";
import { api, fmtDate } from "../../lib/api";

const MSG = "We use QORDEL 360 for ISO quality, safety and environmental management. Start your free trial with my link:";

function shareLinks(link) {
  const t = encodeURIComponent(MSG);
  const u = encodeURIComponent(link);
  return [
    ["Email", `mailto:?subject=${encodeURIComponent("Try QORDEL 360")}&body=${t}%20${u}`],
    ["WhatsApp", `https://wa.me/?text=${t}%20${u}`],
    ["LinkedIn", `https://www.linkedin.com/sharing/share-offsite/?url=${u}`],
    ["Facebook", `https://www.facebook.com/sharer/sharer.php?u=${u}`],
    ["X", `https://twitter.com/intent/tweet?text=${t}&url=${u}`],
    ["SMS", `sms:?&body=${t}%20${u}`],
  ];
}

export function ReferralCard() {
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get("/referrals").then((r) => setD(r.data)).catch(() => {});
  }, []);
  if (!d) return null;
  const copy = (v, label) => navigator.clipboard.writeText(v).then(() => toast.success(`${label} copied`));
  const native = () => navigator.share({ title: "QORDEL 360", text: MSG, url: d.link }).catch(() => {});
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-6" data-testid="referral-card">
      <h2 className="font-semibold text-lg">Refer a business, get a free month</h2>
      <p className="mt-1 text-sm text-slate-600">Share your link or code. When a business you refer subscribes for 6 months or more, we add a free month to your subscription.</p>
      <div className="mt-4 grid sm:grid-cols-[1fr_auto] gap-3">
        <div className="flex gap-2"><input readOnly value={d.link} className="field font-mono text-xs" data-testid="referral-link" /><button onClick={() => copy(d.link, "Link")} className="border border-slate-300 rounded-md px-3" data-testid="referral-copy-link"><Copy className="w-4 h-4" /></button></div>
        <button onClick={() => copy(d.code, "Code")} className="font-mono font-bold tracking-widest border border-sky-200 bg-sky-50 text-sky-800 rounded-md px-4 py-2" data-testid="referral-code">{d.code}</button>
      </div>
      <div className="mt-4 flex flex-wrap gap-2">
        {navigator.share && <button onClick={native} className="inline-flex items-center gap-1.5 bg-sky-600 text-white text-sm font-semibold px-3 py-1.5 rounded-md" data-testid="referral-share-native"><Share2 className="w-4 h-4" />Share</button>}
        {shareLinks(d.link).map(([l, href]) => (
          <a key={l} href={href} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 border border-slate-300 hover:bg-slate-50 text-sm font-semibold px-3 py-1.5 rounded-md" data-testid={`referral-share-${l.toLowerCase()}`}>{l === "Email" && <Mail className="w-4 h-4" />}{l}</a>
        ))}
      </div>
      <div className="mt-5 border-t border-slate-100 pt-4">
        <p className="text-sm font-semibold" data-testid="referral-summary">{d.referrals.length} referral(s) · {d.months_earned} free month(s) earned</p>
        {d.referrals.map((r, i) => (
          <p key={i} className="text-sm text-slate-600 mt-1">{r.referred_name} · signed up {fmtDate(r.created_at)} · {r.status === "rewarded" ? `free month earned ${fmtDate(r.rewarded_at)}` : "waiting for a 6+ month subscription"}</p>
        ))}
      </div>
    </div>
  );
}
